module.exports = __webpack_public_path__ + "static/media/ico-diversidade.f91677ea.svg";